export const ICONS = [
    'vzi-3dots',
    'vzi-add',
    'vzi-addressbook',
    'vzi-agriculture',
    'vzi-airplane',
    'vzi-all-tasks',
    'vzi-alt_route',
    'vzi-anchor',
    'vzi-anchor1',
    'vzi-angry',
    'vzi-angry2',
    'vzi-arrow-down',
    'vzi-arrow-left',
    'vzi-arrow-right',
    'vzi-arrow-up',
    'vzi-assistant_direction',
    'vzi-attach_email',
    'vzi-attach',
    'vzi-attachment',
    'vzi-auto_fix_normal',
    'vzi-baffled',
    'vzi-baffled2',
    'vzi-balance-scale',
    'vzi-barcode',
    'vzi-bell-o',
    'vzi-bell',
    'vzi-birthday-cake',
    'vzi-block',
    'vzi-blocked',
    'vzi-bold',
    'vzi-book',
    'vzi-book1',
    'vzi-bookmark',
    'vzi-bookmark2',
    'vzi-border_all',
    'vzi-border_bottom',
    'vzi-border_clear',
    'vzi-border_horizontal',
    'vzi-border_inner',
    'vzi-border_left',
    'vzi-border_outer',
    'vzi-border_right',
    'vzi-border_top',
    'vzi-border_vertical',
    'vzi-bug',
    'vzi-cabinet',
    'vzi-calendar-check-o',
    'vzi-calendar-minus-o',
    'vzi-calendar-plus-o',
    'vzi-calendar-times-o',
    'vzi-calendar',
    'vzi-calendar1',
    'vzi-calendar2',
    'vzi-call_end',
    'vzi-call_split',
    'vzi-call',
    'vzi-camera_alt',
    'vzi-camera_flip',
    'vzi-camera_front',
    'vzi-camera_rear',
    'vzi-campaign',
    'vzi-cancel-circle',
    'vzi-cancel-send',
    'vzi-cast_connected',
    'vzi-cast',
    'vzi-ch-down',
    'vzi-ch-left',
    'vzi-ch-right',
    'vzi-ch-up',
    'vzi-chat-1',
    'vzi-chat-2',
    'vzi-chat',
    'vzi-chat1',
    'vzi-check',
    'vzi-checked',
    'vzi-close',
    'vzi-cloud-download',
    'vzi-cloud-upload',
    'vzi-cloudy',
    'vzi-clubs',
    'vzi-code-fork',
    'vzi-collapse',
    'vzi-column-insert-after',
    'vzi-column-insert-before',
    'vzi-column-remove',
    'vzi-comment-o',
    'vzi-comment',
    'vzi-completed',
    'vzi-compress',
    'vzi-confused',
    'vzi-confused2',
    'vzi-construction',
    'vzi-contact_mail',
    'vzi-contact_phone',
    'vzi-controller-fast-forward',
    'vzi-controller-jump-to-start',
    'vzi-controller-next',
    'vzi-controller-paus',
    'vzi-controller-play',
    'vzi-controller-stop',
    'vzi-cool',
    'vzi-cool2',
    'vzi-copy',
    'vzi-create_new_folder',
    'vzi-crop_free',
    'vzi-crop',
    'vzi-cross',
    'vzi-crown',
    'vzi-crying',
    'vzi-crying2',
    'vzi-cut',
    'vzi-dashboard',
    'vzi-desktop_access_disabled',
    'vzi-desktop_windows',
    'vzi-device_hub',
    'vzi-diamonds',
    'vzi-done',
    'vzi-draft',
    'vzi-draft2',
    'vzi-draft3',
    'vzi-draft4',
    'vzi-drag-handle',
    'vzi-dropbox',
    'vzi-edit',
    'vzi-edit1',
    'vzi-email',
    'vzi-embed2',
    'vzi-emoji_events',
    'vzi-enter',
    'vzi-error',
    'vzi-evil',
    'vzi-evil2',
    'vzi-exit',
    'vzi-expand',
    'vzi-expand1',
    'vzi-eye-slash',
    'vzi-eye',
    'vzi-facebook',
    'vzi-featured_video',
    'vzi-festival',
    'vzi-file-archive',
    'vzi-file-audio',
    'vzi-file-code',
    'vzi-file-excel',
    'vzi-file-image',
    'vzi-file-pdf',
    'vzi-file-pp',
    'vzi-file-text',
    'vzi-file-video',
    'vzi-file-word',
    'vzi-file',
    'vzi-file1',
    'vzi-file2',
    'vzi-filter_none',
    'vzi-filter',
    'vzi-fire',
    'vzi-flip',
    'vzi-floppy',
    'vzi-flow-cascade',
    'vzi-folder-o',
    'vzi-folder',
    'vzi-format_align_center',
    'vzi-format_align_justify',
    'vzi-format_align_left',
    'vzi-format_align_right',
    'vzi-format_color_fill',
    'vzi-format_color_text',
    'vzi-format_line_spacing',
    'vzi-format_size',
    'vzi-forward_to_inbox',
    'vzi-forward',
    'vzi-frustrated',
    'vzi-frustrated2',
    'vzi-fullscreen-exit',
    'vzi-fullscreen',
    'vzi-gift',
    'vzi-github',
    'vzi-glass',
    'vzi-google',
    'vzi-grin',
    'vzi-grin2',
    'vzi-group',
    'vzi-hammer2',
    'vzi-hand-peace-o',
    'vzi-happy',
    'vzi-happy2',
    'vzi-headphones',
    'vzi-heart',
    'vzi-highlight_alt',
    'vzi-hipster',
    'vzi-hipster2',
    'vzi-history_toggle_off',
    'vzi-history',
    'vzi-home',
    'vzi-horizontal_rule',
    'vzi-house',
    'vzi-idea',
    'vzi-image',
    'vzi-imagesearch_roller',
    'vzi-in',
    'vzi-inbox',
    'vzi-indent-decrease',
    'vzi-indent-increase',
    'vzi-infinite',
    'vzi-info',
    'vzi-input',
    'vzi-instagram',
    'vzi-integration',
    'vzi-integration2',
    'vzi-integration3',
    'vzi-integration4',
    'vzi-italic',
    'vzi-kanban',
    'vzi-kanban2',
    'vzi-kanban3',
    'vzi-key',
    'vzi-lab',
    'vzi-launch',
    'vzi-layout',
    'vzi-layout1',
    'vzi-layout2',
    'vzi-layout3',
    'vzi-layout4',
    'vzi-layout5',
    'vzi-layout6',
    'vzi-layout7',
    'vzi-layout8',
    'vzi-level-down',
    'vzi-level-up',
    'vzi-lightning',
    'vzi-link',
    'vzi-linkedin',
    'vzi-list-check',
    'vzi-list-nested',
    'vzi-list-numbered',
    'vzi-list1',
    'vzi-list2',
    'vzi-live_help',
    'vzi-local_police',
    'vzi-location_off',
    'vzi-location_on',
    'vzi-lock',
    'vzi-logout',
    'vzi-magnet',
    'vzi-mail',
    'vzi-mark_email_read',
    'vzi-medal',
    'vzi-menu_book',
    'vzi-menu',
    'vzi-menu1',
    'vzi-merge-cells',
    'vzi-mic-off',
    'vzi-mic',
    'vzi-minus',
    'vzi-mobile',
    'vzi-moon',
    'vzi-movie',
    'vzi-mug',
    'vzi-multiple_stop',
    'vzi-neutral',
    'vzi-neutral2',
    'vzi-note',
    'vzi-notification',
    'vzi-omega',
    'vzi-ondemand_video',
    'vzi-org',
    'vzi-out',
    'vzi-outbox',
    'vzi-pacman',
    'vzi-palette',
    'vzi-paste',
    'vzi-pause_circle_outline',
    'vzi-paw',
    'vzi-person-o',
    'vzi-person',
    'vzi-phone_callback',
    'vzi-phone_in_talk',
    'vzi-phone_missed',
    'vzi-photo',
    'vzi-picture-o',
    'vzi-pie-chart',
    'vzi-pie-chart1',
    'vzi-pinterest',
    'vzi-play_circle_outline',
    'vzi-plus',
    'vzi-popin',
    'vzi-popout',
    'vzi-project',
    'vzi-qr_code_scanner',
    'vzi-qr_code',
    'vzi-qrcode',
    'vzi-question',
    'vzi-radio-checked2',
    'vzi-rain',
    'vzi-record',
    'vzi-redo',
    'vzi-remove',
    'vzi-repeat',
    'vzi-reply',
    'vzi-resize',
    'vzi-resize1',
    'vzi-restore_from_trash',
    'vzi-return',
    'vzi-rocket',
    'vzi-rotate-left',
    'vzi-rotate-right',
    'vzi-row-insert-after',
    'vzi-row-insert-before',
    'vzi-row-remove',
    'vzi-rule',
    'vzi-sad',
    'vzi-sad2',
    'vzi-search',
    'vzi-send-mail',
    'vzi-send',
    'vzi-settings_ethernet',
    'vzi-settings',
    'vzi-share-alt',
    'vzi-share-screen',
    'vzi-shipping',
    'vzi-shocked',
    'vzi-shocked2',
    'vzi-show-all-task-fields',
    'vzi-sigma',
    'vzi-site',
    'vzi-skype',
    'vzi-sleepy',
    'vzi-sleepy2',
    'vzi-smile',
    'vzi-smile2',
    'vzi-snow',
    'vzi-sort-asc',
    'vzi-sort-desc',
    'vzi-spades',
    'vzi-speed',
    'vzi-split-cell',
    'vzi-spoon-knife',
    'vzi-square_foot',
    'vzi-stack',
    'vzi-star-o',
    'vzi-star',
    'vzi-stats-bars',
    'vzi-stats-dots',
    'vzi-strikethrough',
    'vzi-subscript',
    'vzi-sun',
    'vzi-superscript',
    'vzi-support_agent',
    'vzi-switch_video',
    'vzi-switch',
    'vzi-switch1',
    'vzi-tab',
    'vzi-table2',
    'vzi-tablet_android',
    'vzi-tag-lines',
    'vzi-tag',
    'vzi-tags',
    'vzi-team',
    'vzi-team2',
    'vzi-telegram',
    'vzi-thumb-down',
    'vzi-thumb-up',
    'vzi-thumbs-o-down',
    'vzi-thumbs-o-up',
    'vzi-timer',
    'vzi-tongue',
    'vzi-tongue2',
    'vzi-trash-o',
    'vzi-tree',
    'vzi-tree1',
    'vzi-trophy',
    'vzi-truck',
    'vzi-tty',
    'vzi-tune',
    'vzi-tv',
    'vzi-twitter',
    'vzi-underline',
    'vzi-undo',
    'vzi-update',
    'vzi-user-add',
    'vzi-user-del',
    'vzi-var',
    'vzi-vertical_align_center',
    'vzi-vertical_split',
    'vzi-video_off',
    'vzi-video_settings',
    'vzi-video',
    'vzi-view_in_ar',
    'vzi-vk',
    'vzi-volume_off',
    'vzi-volume_up',
    'vzi-warning',
    'vzi-web',
    'vzi-webhooks',
    'vzi-whatsapp',
    'vzi-window',
    'vzi-windows',
    'vzi-wink',
    'vzi-wink2',
    'vzi-wondering',
    'vzi-wondering2',
    'vzi-worker',
    'vzi-working',
    'vzi-yingyang',
    'vzi-youtube',
    'vzi-zoom-in',
    'vzi-zoom-out',
];
